//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The paypal session model
* 
* @param clientKey The paypal client key
* @param currencyCode The ISO-4217 currency code
* @param paypalOrderId The paypal specific order id
*/
@Serializable

data class PaypalSession (


      /* The paypal client key */
    @SerialName(value = "clientKey") @Required val clientKey: kotlin.String,


      /* The ISO-4217 currency code */
    @SerialName(value = "currencyCode") @Required val currencyCode: kotlin.String,


      /* The paypal specific order id */
    @SerialName(value = "paypalOrderId") @Required val paypalOrderId: kotlin.String


) {




  }

